import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import './CategoriesSection.css';
import fallbackImg from '../assets/categories/globevalve.webp';
import categoriesData from '../data/categories.json';

const ctx = require.context('../assets/categories', false, /\.(png|jpe?g|webp|svg)$/);

function resolveImagePath(path) {
  if (!path) return fallbackImg;
  if (/^https?:\/\//i.test(path)) return path;
  try {
    return ctx(`./${path}`);
  } catch (err) {
    return fallbackImg;
  }
}

export default function CategoriesSection({ categories }) {
  const trackRef = useRef(null);
  const cats = (categories && categories.length ? categories : categoriesData).map((c) =>
    typeof c === 'string' ? { name: c } : c
  );

  const scrollNext = () => {
    const track = trackRef.current;
    if (!track) return;
    track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' });
  };
  const scrollPrev = () => {
    const track = trackRef.current;
    if (!track) return;
    track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' });
  };

  return (
    <section className="full-section categories-section">
      <div className="fw-inner container">
        <div className="cats-header">
          <h3 className="cats-title">Popular Categories</h3>
          <div className="cats-controls">
            <button className="cats-btn" aria-label="Previous" onClick={scrollPrev}>&#8592;</button>
            <button className="cats-btn" aria-label="Next" onClick={scrollNext}>&#8594;</button>
          </div>
        </div>
        
        <div className="cats-track" ref={trackRef}>
          {cats.map((c, i) => (
            <Link to={c.link} className="cat-card" key={i}>
              <div className="cat-thumb">
                <img src={resolveImagePath(c.image)} alt={c.name} />
              </div>
              <div className="cat-name">{c.name}</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
